import {required} from "vuelidate/lib/validators";  
const configs = {
    data() { 
      return {   
        configsData: {    
          Sitebaslik:  null,
          Siteanahtarkelimeler:  null,
          Siteaciklama:  null,
          Googleanalyticsentegrasyonkodu:  null,
          Googleanalyticskeyfilepath:  null,
          Googleanalyticsserviceaccountemail:  null,
          Googleanalyticskeypassword:  null,
          Googleanalyticswebsitecode:  null,
          Contactaddress:  null,
          Contactphone:  null,
          Contactfax:  null,
          Contactemail:  null,
          Contactmap:  null,
          Contactbildirimvarmi:  true,
          Gonderimyapilacakepostalar:  null,
          Epostagonderenadi:  null,
          Epostamailserver:  null,
          Epostamailserverport:  null,
          Epostasslaktif:  true,
          Epostakullaniciadi:  null,
          Epostasifre:  null,
          Facebook:  null,
          Twitter:  null,
          Googleplus:  null,
          Pinterest:  null,
          Linkedin:  null,
          Instegram:  null,
          Youtube:  null,
          Sitelogo:  null,
          Favicon:  null,
          Introductionvideo:  null,
          Homepagetext:  null,
          Websiteid:  null ,
          Kvkk:  null ,
          Kvkkmetni:  null ,
          Kvkktarihi:null,
          Mezungelismisfiltreleme:null,
          Mezunharitagelismisfiltreleme:null,
          Mezunharitatablogozuksun:null,
          Mezunlarbirbirinigorsun: null,
          Isilanlarigelismisfiltreleme: null
          }, 
          FormDataType:{ 
            Sitebaslik:{FieldName:"Sitebaslik",Field:"input",FieldTitle:this.$t('configs.AddEdit.SeoAyarlari.Sitebaslik'),FieldType:"text"},
            Siteanahtarkelimeler:{FieldName:"Siteanahtarkelimeler",Field:"input",FieldTitle:this.$t('configs.AddEdit.SeoAyarlari.Siteanahtarkelimeler'),FieldType:"text"},
            Siteaciklama:{FieldName:"Siteaciklama",Field:"input",FieldTitle:this.$t('configs.AddEdit.SeoAyarlari.Siteaciklama'),FieldType:"text"},
            Googleanalyticsentegrasyonkodu:{FieldName:"Googleanalyticsentegrasyonkodu",Field:"input",FieldTitle:this.$t('configs.AddEdit.SeoAyarlari.Googleanalyticsentegrasyonkodu'),FieldType:"text"},
            Googleanalyticskeyfilepath:{FieldName:"Googleanalyticskeyfilepath",Field:"input",FieldTitle:this.$t('configs.AddEdit.GoogleAnalyticsEntegrasyonu.Googleanalyticskeyfilepath'),FieldType:"text"},
            Googleanalyticsserviceaccountemail:{FieldName:"Googleanalyticsserviceaccountemail",Field:"input",FieldTitle:this.$t('configs.AddEdit.GoogleAnalyticsEntegrasyonu.Googleanalyticsserviceaccountemail'),FieldType:"text"},
            Googleanalyticskeypassword:{FieldName:"Googleanalyticskeypassword",Field:"input",FieldTitle:this.$t('configs.AddEdit.GoogleAnalyticsEntegrasyonu.Googleanalyticskeypassword'),FieldType:"text"},
            Googleanalyticswebsitecode:{FieldName:"Googleanalyticswebsitecode",Field:"input",FieldTitle:this.$t('configs.AddEdit.GoogleAnalyticsEntegrasyonu.Googleanalyticswebsitecode'),FieldType:"text"},
            Contactaddress:{FieldName:"Contactaddress",Field:"input",FieldTitle:this.$t('configs.AddEdit.IletisimBilgileri.Contactaddress'),FieldType:"text"},
            Contactphone:{FieldName:"Contactphone",Field:"input",FieldTitle:this.$t('configs.AddEdit.IletisimBilgileri.Contactphone'),FieldType:"text"},
            Contactfax:{FieldName:"Contactfax",Field:"input",FieldTitle:this.$t('configs.AddEdit.IletisimBilgileri.Contactfax'),FieldType:"text"},
            Contactemail:{FieldName:"Contactemail",Field:"input",FieldTitle:this.$t('configs.AddEdit.IletisimBilgileri.Contactemail'),FieldType:"text"},
            Contactmap:{FieldName:"Contactmap",Field:"input",FieldTitle:this.$t('configs.AddEdit.IletisimBilgileri.Contactmap'),FieldType:"text"},
            Contactbildirimvarmi:{FieldName:"Contactbildirimvarmi",Field:"input",FieldTitle:this.$t('configs.AddEdit.IletisimBilgileri.Contactbildirimvarmi'),FieldType:"text"},
            Gonderimyapilacakepostalar:{FieldName:"Gonderimyapilacakepostalar",Field:"input",FieldTitle:this.$t('configs.AddEdit.IletisimBilgileri.Gonderimyapilacakepostalar'),FieldType:"text"},
            Epostagonderenadi:{FieldName:"Epostagonderenadi",Field:"input",FieldTitle:this.$t('configs.AddEdit.SMTPBilgileri.Epostagonderenadi'),FieldType:"text"},
            Epostamailserver:{FieldName:"Epostamailserver",Field:"input",FieldTitle:this.$t('configs.AddEdit.SMTPBilgileri.Epostamailserver'),FieldType:"text"},
            Epostamailserverport:{FieldName:"Epostamailserverport",Field:"input",FieldTitle:this.$t('configs.AddEdit.SMTPBilgileri.Epostamailserverport'),FieldType:"text"},
            Epostasslaktif:{FieldName:"Epostasslaktif",Field:"input",FieldTitle:this.$t('configs.AddEdit.SMTPBilgileri.Epostasslaktif'),FieldType:"text"}, 
            Epostakullaniciadi:{FieldName:"Epostakullaniciadi",Field:"input",FieldTitle:this.$t('configs.AddEdit.SMTPBilgileri.Epostakullaniciadi'),FieldType:"text"},
            Epostasifre:{FieldName:"Epostasifre",Field:"input",FieldTitle:this.$t('configs.AddEdit.SMTPBilgileri.Epostasifre'),FieldType:"text"}, 
            Facebook:{FieldName:"Facebook",Field:"input",FieldTitle:this.$t('configs.AddEdit.SosyalMedya.Facebook'),FieldType:"text"},
            Twitter:{FieldName:"Twitter",Field:"input",FieldTitle:this.$t('configs.AddEdit.SosyalMedya.Twitter'),FieldType:"text"}, 
            Googleplus:{FieldName:"Googleplus",Field:"input",FieldTitle:this.$t('configs.AddEdit.SosyalMedya.Googleplus'),FieldType:"text"},
            Pinterest:{FieldName:"Pinterest",Field:"input",FieldTitle:this.$t('configs.AddEdit.SosyalMedya.Pinterest'),FieldType:"text"}, 
            Linkedin:{FieldName:"Linkedin",Field:"input",FieldTitle:this.$t('configs.AddEdit.SosyalMedya.Linkedin'),FieldType:"text"},
            Instegram:{FieldName:"Instegram",Field:"input",FieldTitle:this.$t('configs.AddEdit.SosyalMedya.Instegram'),FieldType:"text"}, 
            Youtube:{FieldName:"Youtube",Field:"input",FieldTitle:this.$t('configs.AddEdit.SosyalMedya.Youtube'),FieldType:"text"},
            Sitelogo:{FieldName:"Sitelogo",Field:"input",FieldTitle:this.$t('configs.AddEdit.Gorseller.Sitelogo'),FieldType:"text"}, 
            Favicon:{FieldName:"Favicon",Field:"input",FieldTitle:this.$t('configs.AddEdit.Gorseller.Favicon'),FieldType:"text"},
            Introductionvideo:{FieldName:"Introductionvideo",Field:"input",FieldTitle:this.$t('configs.AddEdit.Gorseller.Introductionvideo'),FieldType:"text"}, 
            Kvkk:{FieldName:"Kvkk",Field:"checkbox",FieldTitle:this.$t('configs.AddEdit.Kvkk.Kvkk'),FieldType:"text"}, 
            Kvkkmetni:{FieldName:"Kvkkmetni",Field:"textarea",FieldTitle:this.$t('configs.AddEdit.Kvkk.Kvkkmetni'),FieldType:"text"}, 
            Kvkktarihi:{FieldName:"Kvkktarihi",Field:"date",FieldTitle:this.$t('configs.AddEdit.Kvkk.Kvkktarihi'),FieldType:"text"}, 
            Mezungelismisfiltreleme:{FieldName:"Mezungelismisfiltreleme",Field:"checkbox",FieldTitle:this.$t('configs.AddEdit.MezunConfig.Mezungelismisfiltreleme'),FieldType:"text"}, 
            Mezunharitagelismisfiltreleme:{FieldName:"Mezunharitagelismisfiltreleme",Field:"checkbox",FieldTitle:this.$t('configs.AddEdit.MezunConfig.Mezunharitagelismisfiltreleme'),FieldType:"text"}, 
            Mezunharitatablogozuksun:{FieldName:"Mezunharitatablogozuksun",Field:"checkbox",FieldTitle:this.$t('configs.AddEdit.MezunConfig.Mezunharitatablogozuksun'),FieldType:"text"}, 
            Mezunlarbirbirinigorsun:{FieldName:"Mezunlarbirbirinigorsun",Field:"checkbox",FieldTitle:this.$t('configs.AddEdit.MezunConfig.Mezunlarbirbirinigorsun'),FieldType:"text"}, 
            Isilanlarigelismisfiltreleme:{FieldName:"Isilanlarigelismisfiltreleme",Field:"checkbox",FieldTitle:this.$t('configs.AddEdit.MezunConfig.Isilanlarigelismisfiltreleme'),FieldType:"text"}, 
          } 
      }
    }, 
    validations:{ 
      FormData: {  
        Sitebaslik: { required},  
        Siteanahtarkelimeler: {  }, 
        Siteaciklama: {  },  
        Googleanalyticsentegrasyonkodu: {  },  
        Googleanalyticskeyfilepath: {  },  
        Googleanalyticsserviceaccountemail: {  },  
        Googleanalyticskeypassword: {  },  
        Googleanalyticswebsitecode: {  },  
        Contactaddress: {  },  
        Contactphone: {  },  
        Contactfax: {  },  
        Contactemail: {  },  
        Contactmap: {  },  
        Contactbildirimvarmi: {  },  
        Gonderimyapilacakepostalar: {  },  
        Epostagonderenadi: {  },  
        Epostamailserver: {  },  
        Epostamailserverport: {  },  
        Epostasslaktif: {  },  
        Epostakullaniciadi: {  },  
        Epostasifre: {  },    
        Facebook: {  },  
        Twitter: {  },  
        Googleplus: {  },  
        Pinterest: {  },  
        Linkedin: {  },  
        Instegram: {  },  
        Youtube: {  },  
        Sitelogo: {  },  
        Favicon: {  },  
        Introductionvideo: {  } ,
        Kvkk: {  } ,
        Kvkkmetni: {  } ,
        Kvkktarihi:{} ,
        Mezungelismisfiltreleme:{} ,
        Mezunharitagelismisfiltreleme:{} ,
        Mezunharitatablogozuksun:{},
        Mezunlarbirbirinigorsun: {},
        Isilanlarigelismisfiltreleme: {}
      }
 
  }, 
  created(){ 
  } 

}
export default configs